module.exports = __webpack_public_path__ + "static/media/advertising-preview.bf704df2.png";